export const PAGE_TITLE= {
    home: 'home',
    logIn: 'login',
    mfaPage: 'mfapage',
    notFound: 'Error404',
    detail: 'detail',
    cart: 'cart',
    checkout: 'conferma_ordine',
    success: 'success'
}

export const APP_TYPE=1;